import { SET_USER, REMOVE_USER } from "./mutations";

const initialState = null;

const userReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_USER:
      return payload;

    case REMOVE_USER:
      return null;

    default:
      return state;
  }
};

export default userReducer;
